import axios from "axios";
import Cookies from 'js-cookie';
import store from './store';
import AuthConstants from './store/auth/constants';
import UIConstants from './store/ui/constants';
import router from "@/router";

const httpClient = axios.create();
httpClient.defaults.baseURL = process.env.VUE_APP_DOMAIN + '/api';
httpClient.defaults.timeout = 10000;

httpClient.interceptors.request.use(
    (request) => {
        const methods = ['post', 'patch', 'put', 'delete'];
        if (methods.includes(request.method.toLowerCase())) {
            request.headers['X-CSRFToken'] = Cookies.get('csrftoken');
        }
        return request;
    },
    (error) => { return Promise.reject(error) });



httpClient.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (axios.isCancel(error)) {
            return Promise.reject(error)
        }
        if (error.response && error.response.status === 401 && store.getters.isAuthenticated) {
                store.dispatch(AuthConstants.AuthActions.AUTH_LOGOUT,
                    {message: 'Сессия устарела, пожалуйста, войдите в систему снова'}).then(() => {
                    return store.dispatch(UIConstants.UIActions.UI_CLEAN_BREADCRUMBS);
                });
            }
        return Promise.reject(error);
    });

httpClient.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (axios.isCancel(error)) {
            // console.log(error)
            return Promise.reject(error)
        }
        if (error.response && error.response.status === 403 && store.getters.isAuthenticated) {
            return router.replace('/forbidden')
        }
        if (error.response && error.response.status === 404 && store.getters.isAuthenticated) {
            return router.replace('/notfound')
        }
    return Promise.reject(error);
});



export default httpClient;